import Drawer from 'react-modern-drawer';
import React, { Suspense, useState, useEffect, useRef } from "react";
import DataLoaderFileLog from "components/DataLoading/DataLoaderFileLog";
import PaymentServices from './PaymentServices';
import DataLoaderFileValidation from 'components/DataLoading/DataLoaderFileValidation';
import DataLoaderLoadFile from 'components/DataLoading/DataLoaderLoadfile';
import DeleteDialogueBox from 'components/Common/deleteDialogue';

export default function SuggestedPaymentUploadBox(param: any) {
    console.log(param)


    let [uploadCount, setUploadCount] = useState(0);
    let [LogName, setLogName] = useState("SPY");
    let [fileToUpload, setfileToUpload] = useState(null);
    let [LoadFileStatus, setLoadFileStatus] = useState(false);
    const [confirmLoadFile, setconfirmLoadFile] = useState(false);
    let [viewUploadStatus, setViewUploadStatus] = useState(false);
    let [fileuploadStatus, setfileuploadStatus] = useState(false);
    let [suggestedPaymentList, setSuggestedPaymentList] = useState<any>([]);
    var pagination_payload = { pageNumber: 1, pageSize: 10 }

    useEffect(() => {

        upload_list();

    }, []);

    const upload_list = () => {
        PaymentServices.suggestedPaymentsCount().then((value: any) => {
            uploadCount = value;
            setUploadCount(uploadCount);

            PaymentServices.suggestedPaymentSelectList(pagination_payload).then((value: any) => {
                suggestedPaymentList = value
                setSuggestedPaymentList(suggestedPaymentList)
            })
        })
    }

    const viewUploadFileLog = () => {
        viewUploadStatus = true;
        setViewUploadStatus(viewUploadStatus)
    }

    const onClose = () => {
        param.SuggestedPaymentUploadClose();
    }

    const onChangeLogFile = (e: any) => {
        setViewUploadStatus(false)
    }

    const fileupload = (event: any) => {
        const fileName = event.target.files[0];
        console.log(event)
        if (fileName) {
            setfileToUpload(fileName);
            fileuploadStatus = true
            setfileuploadStatus(fileuploadStatus);
        }
    }

    const onFileValidation = (e: any) => {
        setLoadFileStatus(false);
        //ViewUploadList();
    }

    const suggestedPaymentClear = () => {
        PaymentServices.suggestedPaymentclear();
    }

    const uploadData = () => {
        PaymentServices.suggestedPaymentFileUpload(fileToUpload)
    }

    const onChangeLoadFile = (e: any) => {
        if (e === 1) {
            //Appen
            uploadData();
        }
        if (e === 2) {
            //clear
            suggestedPaymentClear();
            uploadData();
        }
        if (e === 3) {
            //load
            uploadData();
        }
        if (e === 0) {
            setconfirmLoadFile(false);
        }

        setconfirmLoadFile(false)
    }


    const [uploadFail, setUploadFail] = useState(false);
    const [uploadPass, setUploadPass] = useState(false);
    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);

    const deleteSuggestedPayment = (selectData: any) => {
        deleteStatus = true;
        setDeleteStatus(deleteStatus)

        deleteData = selectData;
        setDeleteData(deleteData)
    }

    const DeleteDialogueBoxClose = (e: any) => {
        //e==1 YES 
        if (e == 1) {
            //uploadDelete();        
            PaymentServices.suggestedPaymentDelete(deleteData?.tempSuggestedPaymentID).then((respond: any) => {
                upload_list()
            })
        }
        //e==2 NO 
        deleteStatus = false
        setDeleteStatus(false)
    }

    return (
        <>
            <Drawer open={param.param} onClose={onClose} direction='right' className='react-drawer allowVscroll allowHscroll' size={800} >

                <div className="ws-6 pull-right box">

                    <div className="ws-12">
                        <div className="box-header-main"> <h2>Suggested Payment Upload</h2>  </div>

                        <div className="box-content">
                            {uploadFail && <div className="alert alert-danger" >Incorrect file uploaded.Please check file history.</div>}
                            {uploadPass && <div className="alert alert-success">File successfully uploaded.</div>}

                            <div className="form-format ws-12">
                                <div className="form-format ws-12">

                                    <label className="control-label ">File Upload</label>
                                    <label className="icon-btn labelInfo width120 height35 mt mrl">Upload File
                                        <input type="file" accept="pdf/*" onChange={(e) => fileupload(e)} className="hide" />
                                    </label>

                                    <div className="ws-9 mt height35">
                                        <div className="progress m1">
                                            <div className="progress-fill" style={{ width: "0%" }}>  0 % </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="box-footer">
                            {uploadCount > 0 && <button className="btn icon-btn delete m0 mr pull-left" onClick={suggestedPaymentClear} title="Clean">
                                <i className="icon-close"></i> Clean
                            </button>}

                            {uploadCount > 0 && <button className="btn icon-btn edit m0 mr pull-right" onClick={() => setLoadFileStatus(true)} title="Validation">Validation </button>}

                            {(fileuploadStatus) && <button className="btn icon-btn edit m0 mr pull-right" onClick={uploadData} title="Upload">Upload  </button>}

                            <button className="btn icon-btn edit m0 mr pull-right" onClick={() => viewUploadFileLog()} title="File History"> File History </button>
                        </div>
                    </div>

                    <div className="box-footer">

                        <div className="box mtl ">
                            <div className="box-header well">  <h2 > {uploadCount} record(s) found  </h2>  </div>

                            <div className="box-content">

                                {uploadCount == 0 && <div className="alert alert-info mt ">No records to display</div>}

                                {uploadCount > 0 && <div className="control-group">
                                    <div className="table-responsive allowHscroll allowVscroll">
                                        <table className="table mt">
                                            <thead>
                                                <tr className="list">
                                                    <th className='forceSingleLine'>Contract Ref Num</th>
                                                    <th className='forceSingleLine'>Contract Title</th>
                                                    <th className='forceSingleLine'>Contact</th>
                                                    <th className='forceSingleLine'>Suggested Payment</th>
                                                    <th className='forceSingleLine'>Payment</th>
                                                    <th className='forceSingleLine'>Payment Description</th>
                                                    <th className='forceSingleLine'>Period</th>
                                                    <th className='forceSingleLine'>Status</th>
                                                    <th className='forceSingleLine'>Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    suggestedPaymentList?.map((val: any) => {
                                                        return (
                                                            <tr>
                                                                <td>{val.contract}</td>
                                                                <td>{val.title}</td>
                                                                <td>{val.contactBalance}</td>
                                                                <td>{val.suggestedPayment}</td>
                                                                <td>{val.paymentMade}</td>
                                                                <td>{val.paymentDescription}</td>
                                                                <td>{val.payPeriod}</td>
                                                                <td>{val.status}</td>
                                                                <td>
                                                                    <button className="icon-btn delete" onClick={() => deleteSuggestedPayment(val)}><i className="icon-trashcan"></i> </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="pull-left mt">


                                    </div>
                                </div>}

                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete btn-sm width100 height35" onClick={onClose} > Close</button>
                            </div>
                        </div>

                    </div>
                </div>

            </Drawer>
            {
                (() => {

                    if (viewUploadStatus) {
                        return (<DataLoaderFileLog onChangeLogFile={onChangeLogFile} open={viewUploadStatus} type={LogName} />)
                    }

                    if (LoadFileStatus) {
                        return (<DataLoaderFileValidation onFileValidation={onFileValidation} open={LoadFileStatus} type={"suggestedPayments"} subType={"suggestedPayments"} uploadCount={uploadCount} />)
                    }

                    if (confirmLoadFile) {
                        return (<DataLoaderLoadFile onChangeLoadFile={onChangeLoadFile} open={confirmLoadFile} type={"suggestedPayments"} subType={"suggestedPayments"} />)
                    }

                    if (deleteStatus) {
                        return <DeleteDialogueBox param={deleteStatus} onChange={DeleteDialogueBoxClose} />
                    }
                })()
            }
        </>
    )
}